module.exports = __webpack_public_path__ + "static/media/wand.a076a1ad.svg";